import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from 'Components/svg/SvgIcon';

class checkboxComponent extends React.Component {
	constructor( props ) {
		super(props);
		this.state = {
			itemChecked: !!props.checked
		};
	}

	componentWillReceiveProps( nextProps ) {
		if( nextProps.checked !== this.state.itemChecked ) {
			this.setState( { itemChecked: nextProps.checked } );
		}
	}

	onChangeHandle = ( event ) => {
		this.setState( { itemChecked: event.target.checked } );

		if( this.props.onChange ) {
			this.props.onChange( event );
		}
	};

	render() {
		let { name, id, value, multiple, label, postLabel, className } = this.props,
			type = multiple ? 'checkbox' : 'radio',
			text = label ? <span>{ label }</span> : null,
			postText = postLabel ? <span>{ postLabel }</span> : null,
			icon = ( multiple ? 'checkbox' : 'radio' ) + ( this.state.itemChecked ? '_checked' : '' ),
			label_class = ( this.state.itemChecked ? 'checked ' : '' ) + className;

		return (
			<label className={ `custom-checkbox ${label_class}` } onClick={ ( e ) => e.stopPropagation() } >
				{ text }
				<input
					name={ name }
					id={ id }
					value={ value }
					checked={ this.state.itemChecked  }
					onChange={ this.onChangeHandle }
					type={ type }
					className="custom-checkbox"/>
				<div className="icon">
					<SvgIcon icon={ icon } size="24px" />
				</div>
				{ postText }
			</label>
		);
	}
}

checkboxComponent.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	multiple: PropTypes.bool.isRequired,
	checked: PropTypes.bool.isRequired,
	label: PropTypes.oneOfType([
    	PropTypes.string,
    	PropTypes.array
	]),
	postLabel: PropTypes.oneOfType([
    	PropTypes.string,
    	PropTypes.array
	]),
	onClick: PropTypes.func,
	onChange: PropTypes.func
};

export default checkboxComponent;


// WEBPACK FOOTER //
// ./src/components/common/CheckboxComponent.js